export default function initMobileMenu() {
    const body = document.querySelector('body');
    const toggleButtons = document.querySelectorAll('.mobile-menu-toggle-holder');
    const toggleChildrenButtons = document.querySelectorAll('.nav-arrow');

    for (const el of toggleButtons) {
        el.addEventListener('click', () => {
            if (body.classList.contains('mobile-menu-open')) {
                body.classList.remove('mobile-menu-open');
            } else {
                body.classList.add('mobile-menu-open');
            }
        })
    }

    for (const el of toggleChildrenButtons) {
        el.addEventListener('click', () => {
            const children = el.parentNode.parentNode.querySelector('.nav-children');

            if (children.classList.contains('active')) {
                children.classList.remove('active');
                el.classList.remove('active');
            } else {
                children.classList.add('active');
                el.classList.add('active');
            }
        })
    }
}
